<!-- ******************************* -->
<!--            LOGIN FORM           -->
<!-- ******************************* -->
<div class="parent" *ngIf="isCheckedToken">
  <div class="fullHeight">
    <mat-card class="loginCard" [style.width.%]="(isMobile) ? 80 : ((isSmallScreen) ? 60 : ((isMediumScreen) ? 40 : 28) )">
      <!-- ******************************* -->
      <!--              LOGO               -->
      <!-- ******************************* -->
      <img src="assets/logo.png"
           class="loginLogo centeredElement"
           alt="aiknowLogo"/>

      <!-- ******************************* -->
      <!--     ENVIRONMENT INDICATION      -->
      <!-- ******************************* -->
      <h3 class="subLogoLogin loginTitle">{{gmService.APP_NAME}}</h3>
      <h3 class="subLogoLogin loginSubTitle">{{'LOGIN.LOGIN_MESSAGE' | translate }}</h3>
      <h3 class="subLogoLogin envType" *ngIf="printEnvironments() !== 'prod'">Environment: {{printEnvironments()}}</h3>
      <form #loginForm="ngForm">

        <!-- ******************************* -->
        <!--       USERNAME INPUT FIELD      -->
        <!-- ******************************* -->
        <mat-form-field class="fullWidthField">
          <mat-label>{{'LOGIN.USERNAME' | translate }}</mat-label>
          <input matInput required #userInput="ngModel" name="username" [(ngModel)]="username">
          <mat-error *ngIf="userInput.invalid">
            {{'LOGIN.USERNAME_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- ******************************* -->
        <!--       PASSWORD INPUT FIELD      -->
        <!-- ******************************* -->
        <mat-form-field class="fullWidthField">
          <mat-label>{{'LOGIN.PASSWORD' | translate }}</mat-label>
          <input  type="password" matInput required #pswdInput="ngModel" name="password" [(ngModel)]="password">
          <mat-error *ngIf="pswdInput.invalid">
            {{'LOGIN.PASSWORD_FIELD' | translate }} {{'COMMON.IS_REQUIRED' | translate }}
          </mat-error>
        </mat-form-field>

        <!-- ******************************* -->
        <!--         REMEMBER ME FLAG        -->
        <!-- ******************************* -->
        <mat-slide-toggle color="primary"
                          [labelPosition]="LABEL_POSITION"
                          [(ngModel)]="rememberMeFlag"
                          name="rememberMeToggle"
                          class="toggleMargins">
          {{'LOGIN.REMEMBER_ME' | translate }}
        </mat-slide-toggle>

        <!-- ******************************* -->
        <!--          LOGIN BUTTON           -->
        <!-- ******************************* -->
        <button mat-raised-button color="primary" class="centeredElement" (click)="login()">{{'LOGIN.LOG_IN' | translate }}</button>

        <!--        <p class="centeredText textWithBigMargin clickableText textFont" (click)="openForgotPassword()">{{'LOGIN.FORGOT_PASSWORD' | translate }}</p>-->
      </form>
    </mat-card>
  </div>
  <div class="rightFooter">
    <span><em>Powered by  </em></span>
    <a title="AIknow" href="https://aiknow.io" rel="noopener" target="_blank"><img alt="aiknowLogo" class="verticalCenter" src="assets/aiknowLogoSm.png"></a>
  </div>
</div>
